export enum AuthFailLogParamKey {
  Step = 'step',
  Result = 'result',
  Reason = 'reason',
  CpoCode = 'cpo_code'
}

export type TAuthFailLogParamValue = string | number | boolean | null | undefined;
export type TAuthFailLogParams = Partial<Record<AuthFailLogParamKey, TAuthFailLogParamValue>>;

const AUTH_FAIL_LOG_PARAM_KEYS: AuthFailLogParamKey[] = [
  AuthFailLogParamKey.Step,
  AuthFailLogParamKey.Result,
  AuthFailLogParamKey.Reason,
  AuthFailLogParamKey.CpoCode
];

const normalizeAuthFailLogValue = (value: TAuthFailLogParamValue) => {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  return String(value);
};

export const buildAuthFailPath = (params: TAuthFailLogParams = {}) => {
  const searchParams = new URLSearchParams();
  const cpoCode = normalizeAuthFailLogValue(params[AuthFailLogParamKey.CpoCode]);
  const pathname = cpoCode ? `/authFail/${encodeURIComponent(cpoCode)}` : '/authFail';

  AUTH_FAIL_LOG_PARAM_KEYS.forEach((key) => {
    const value = normalizeAuthFailLogValue(params[key]);

    if (value) {
      searchParams.set(key, value);
    }
  });

  const search = searchParams.toString();

  return search ? `${pathname}?${search}` : pathname;
};
